import React from 'react';
import { Link } from 'react-router-dom';
import './FooterCTA.css';

function FooterCTA() {
  const currentYear = new Date().getFullYear();

  const legalLinks = [
    {
      label: 'Privacy Policy',
      href: 'https://durbhasigurukulam.com/privacy-policy'
    },
    {
      label: 'Terms of Service',
      href: 'https://durbhasigurukulam.com/terms-of-service'
    },
    {
      label: 'Refund Policy',
      href: 'https://durbhasigurukulam.com/refund-policy'
    }
  ];

  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-shell">
          <div className="footer-brand">
            <span className="footer-kicker">Durbhasi Gurukulam</span>
            <h2 className="footer-title">A thoughtful space for modern digital learning.</h2>
            <p className="footer-description">
              Expert-led courses, guided learning paths, and student-first support for meaningful education.
            </p>
          </div>

          <div className="footer-links">
            <div className="footer-column">
              <h3 className="footer-heading">Quick Links</h3>
              <Link to="/" className="footer-link">Home</Link>
              <Link to="/courses" className="footer-link">Courses</Link>
              <Link to="/support" className="footer-link">Quick Support</Link>
            </div>

            <div className="footer-column">
              <h3 className="footer-heading">Legal</h3>
              {legalLinks.map((link) => (
                <a
                  key={link.href}
                  className="footer-link"
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {link.label}
                </a>
              ))}
            </div>

            <div className="footer-column">
              <h3 className="footer-heading">Learning Promise</h3>
              <p className="footer-meta">Structured lessons</p>
              <p className="footer-meta">Flexible access</p>
              <p className="footer-meta">Responsive support</p>
            </div>

            <div className="footer-column">
              <h3 className="footer-heading">Contact</h3>
              <a className="footer-link" href="mailto:info@durbhasigurukulam.com">info@durbhasigurukulam.com</a>
              <a className="footer-link" href="tel:+917852034945">+91 7852034945</a>
              <p className="footer-meta">Jodhpur, Rajasthan, India</p>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copy">© {currentYear} Durbhasi Gurukulam. All rights reserved.</p>
          <p className="footer-tagline">Learning with purpose, powered by technology.</p>
        </div>
      </div>
    </footer>
  );
}

export default FooterCTA;
